import { mapKeys } from 'lodash-es'

export const PENDING = 'PENDING'
export const IN_PROGRESS = 'IN_PROGRESS'
export const COMPLETED = 'COMPLETED'
export const ERROR = 'ERROR'

export const POLL_INTERVAL_MS = 15000

export const SCRAPING_SESSION_VALIDATION_STATUSES = mapKeys(
  [
    { name: 'Pending', value: PENDING },
    { name: 'In progress', value: IN_PROGRESS },
    { name: 'Completed', value: COMPLETED },
    { name: 'Failed', value: ERROR },
  ],
  'value',
)
